// extracted by mini-css-extract-plugin
export var slideTitle = "slide-module--slideTitle--cee6c";